<template>
    <div class="banner-container">
      <div class="banner-img" :style="{backgroundImage:'url(' + bannerInfo.imgUrl + ')'}"></div>
      <div class="banner-content">
        <div class="banner-title">{{bannerInfo.title}}</div>
        <div class="banner-info">{{bannerInfo.info}}</div>
        <div class="banner-info" v-if="bannerInfo.info2">{{bannerInfo.info2}}</div>
        <div class="banner-button" @click="downloadExcel(bannerInfo.xlsxUrl, bannerInfo.newPage)" v-if="bannerInfo.buttonText">{{bannerInfo.buttonText}}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'banner',
  props: ['bannerInfo'],
  methods: {
    downloadExcel(url, newPage) {
      if (newPage) {
        window.open(url, '_blank');
        return;
      }
      window.open(url, '_self');
    }
  }
};
</script>

<style lang="less" scoped>
.banner-container{
  width: 100%;
  height: 100%;
  position: relative;
  color: #ffffff;
  div{
    box-sizing: border-box;
  }
  .banner-img{
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  .banner-content{
    position: absolute;
    top: 55%;
    width: 100%;
    transform: translateY(-50%);
    text-align: center;
    .banner-title{
      margin: 0 0 25px;
      font-size: 34px;
      letter-spacing: 4px;
      line-height: 50px;
    }
    .banner-info{
      font-size: 16px;
      line-height: 1.8;
    }
    .banner-button{
      margin-top: 45px;
      margin-left: auto;
      margin-right: auto;
      width: 140px;
      height: 40px;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      border: 2px solid #ffffff;
      &:hover{
        background-color: rgba(255,255,255,0.25);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/common/SolutionBanner.vue